import { useEffect } from "react";

export function useTitleSetter(title: string) {
  useEffect(() => {
    document.title = title;
  }, [title]);
}
